<template>
  <vue-modal :active="active" container-class="bg-smoke" @closed="$emit('closed')">
    <div class="box p-0">
      <family-form :model="family"
                   :resource="resource"
                   :action="action"
                   :canUpdate="canUpdate"
                   :canDelete="canDelete"
                   @created="handleCreated"
                   @updated="handleUpdated"
                   @deleted="handleDeleted"/>
    </div>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import resource from '../../mixins/resource';
import FamilyForm from './FamilyForm.vue';

export default {
  mixins: [modal, resource],

  components: { FamilyForm },

  computed: {
    family() {
      return this.data;
    },
    resource() {
      return 'families';
    },
  },

  methods: {
    handleCreated(family) {
      Event.fire('familyCreated', family);
    },
    handleUpdated(family) {
      Event.fire('familyUpdated', family);
    },
    handleDeleted(family) {
      Event.fire('familyDeleted', family);
    },
  },
};
</script>